module.exports = __webpack_public_path__ + "static/vf-button-shoes.2389b181.svg";